// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"c07eb0ab","609":"a46b9f5a","628":"cbbea632","672":"85da6d6e","737":"7236350d","763":"09ba6b0c","782":"014c6f87","787":"e8865e4a","896":"bdd261aa","945":"63281ab3","972":"84f6c4ac"}[chunkId] + ".chunk.js";
};